var styles = {"fontElementMap":"I27U1","orderedlist":"jozXz","bulletedlist":"ANmgQ","listItem":"I-VPx"};

export { styles as s };
//# sourceMappingURL=lists-ba1d978a.js.map
